import React, { useContext } from 'react'
import { Paper, useTheme } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { ApiDataWrapperContext } from '../../contexts/ApiDataWrapper'
import LinkWithQuery from '../LinkWithQuery'
import Text from '../Text'
import { itensDaHome } from '../../layouts/navItems'

// Os cartões de ação da tela inicial. Existem para que o cliente consiga
// trabalhar sem precisar entender a navegação: cada cartão diz, em uma frase,
// o que aquela página faz. Saem da mesma lista da navegação, então uma página
// nova aparece aqui sozinha — e some sozinha para quem o plano não cobre.

export default function HomeActions() {
  const theme = useTheme()
  const { user } = useContext(ApiDataWrapperContext)
  const acoes = itensDaHome(user)

  if (acoes.length === 0) return null

  return (
    <section aria-label="O que você quer fazer">
      <Text className="font-black text-xl md:text-2xl mb-4">
        O que você quer fazer?
      </Text>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 md:gap-4">
        {acoes.map(item => {
          const Icone = item.icon

          return (
            <LinkWithQuery key={item.to} to={item.to} style={{ textDecoration: 'none' }}>
              <Paper
                elevation={0}
                className="h-full p-4 md:p-5 rounded-xl transition-colors"
                style={{ border: `1px solid ${theme.palette.divider}` }}
                sx={{ '&:hover': { borderColor: theme.palette.primary.main } }}
              >
                <div className="flex items-start gap-3">
                  <Icone style={{ fontSize: 26, color: theme.palette.primary.main }} />
                  <div className="flex-1 min-w-0">
                    <Text className="font-black text-base">{item.label}</Text>
                    <Text className="text-sm opacity-70 leading-snug">{item.descricao}</Text>
                  </div>
                  <ChevronRightIcon style={{ fontSize: 20, opacity: 0.35 }} />
                </div>
              </Paper>
            </LinkWithQuery>
          )
        })}
      </div>
    </section>
  )
}
